import { Channel } from '@/types/analytics';
import { StripedDataGrid } from '@/util/datagrid';
import { Dialog, DialogContent, DialogContentText } from '@mui/material';
import { FC } from 'react';
import { channelColumns } from '../columns';

type ChannelInfoProps = {
  channels: Channel[];
  onClose: () => void;
};

const ChannelInfo: FC<ChannelInfoProps> = ({ channels, onClose }) => {
  return (
    <Dialog open={Boolean(channels.length > 0)} onClose={onClose} maxWidth='xl' fullWidth>
      <DialogContent>
        <DialogContentText>Channel Info</DialogContentText>
        <StripedDataGrid
          columns={channelColumns()}
          rows={channels}
          getRowId={(row) => row.channel}
          localeText={{ noRowsLabel: 'No reports available' }}
          isRowSelectable={() => false}
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
          getRowClassName={(params: any) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
          sx={{ '& .MuiDataGrid-cell:focus': { outline: 'none' } }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ChannelInfo;
